<template>
  <autocomplete v-model="searchQuery" :options="options" :onItemSelected="onSearchItemSelected" :onInputChange="onInputChange" :required="required">
    <div slot="item" slot-scope="props" class="single-item">
      <div class="float-left mr-2" v-if="withPicture">
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle" alt="img" :style="'display: inline-block; width: ' + (profilePictureSize.indexOf('px') !== -1 ? profilePictureSize : profilePictureSize + 'px') + '; height: ' + (profilePictureSize.indexOf('px') !== -1 ? profilePictureSize : profilePictureSize + 'px') + '; background: url(' + (props.item.profile_picture || 'https://www.gravatar.com/avatar/default?s=' + profilePictureSize.replace('px', '') + '&r=pg&d=mm') + ') transparent no-repeat 50% 50%/cover;'" />
      </div>
      <div>
        <span v-translate="{data: props.item.id}">ID: %{data}</span><br>
        <span v-translate="{data: props.item.email}">Email: %{data}</span><br>
        <span v-translate="{data: props.item.name}">Name: %{data}</span>
      </div>
    </div>
  </autocomplete>
</template>
<script>
import Autocomplete from '@/components/autocompletes/Autocomplete'

export default {
  name: 'UserAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    restrictToRoles: {
      type: Array,
      default: () => []
    },
    withPicture: {
      type: Boolean,
      default: false
    },
    includes: {
      type: Array,
      default: () => ['roles']
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      },
      currentMssgClass: 'left',
      profilePictureSize: '50'
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('User Name or Email')
    }
  },
  methods: {
    onInputChange(query) {
      let params = {
        includes: this.includes,
        sort: [
          {
            key: 'name',
            direction: 'asc'
          },
          {
            key: 'id',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            or: true,
            filters: [
              ['email', 'ct', query.trim()],
              ['name', 'ct', query.trim()]
            ]
          }
        ]
      }
      if (this.restrictToRoles.length > 0) {
        params.filter_groups.push({
          filters: [
            ['roles.name', 'in', this.restrictToRoles]
          ]
        })
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (query.trim().length >= this.minCharacter) {
        return new Promise(resolve => {
          this.$http.get(this.$appConfig.api.baseUrl + 'users', {params: params})
            .then(response => {
              resolve(response.body.data)
            })
        })
      }
    },
    onSearchItemSelected(item) {
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}

</script>
<style lang="scss">
.v-suggestions {
  width: 100%;

  &:before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    background: transparent url(../../assets/img/ic-autocomplete-search.svg) no-repeat 50% 50%;
    background-size: contain;
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%)
  }

  input {
    padding-left: 30px;
  }

  .items {
    .item {

      &.is-active,
      &:hover {
        background: rgba(0, 180, 255, 0.15) !important;
      }
    }
  }
}

</style>
